
import { Badge } from "@/components/ui/badge";
import { PartSubcategory } from "@/data/parts";

interface PartCardSubcategoryProps {
  subcategory: PartSubcategory;
  handleSubcategoryClick: (e: React.MouseEvent, subcategory: PartSubcategory) => void;
}

const PartCardSubcategory = ({ subcategory, handleSubcategoryClick }: PartCardSubcategoryProps) => {
  return (
    <Badge
      variant="outline"
      className="self-start mb-3 cursor-pointer hover:opacity-80 transition-opacity bg-transparent border-border"
      onClick={(e) => handleSubcategoryClick(e, subcategory)}
    >
      {subcategory}
    </Badge>
  );
};

export default PartCardSubcategory;
